import React from 'react';
import {Avatar} from 'antd';

import {Test} from '../RequestView/SimpleRequestView';

import DocumentIcon from '../icons/DocumentIcon';

import Tooltip from 'antd/es/tooltip';

import {TestDescroptionModal} from './TestDescriptionModal';
import styled from 'styled-components';
import HeaderLabel from '../StyledComponents/HeaderLabel';
import StyledLink from '../StyledComponents/StyledLink';
import {useTranslation} from "@nic-react-i18n/core";


interface TestTypeViewInterface {
    test: Test;
    row: boolean;
}
type TestTypeViewProps = TestTypeViewInterface

const TestContainerBase = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
`;

const TestContainerRow = styled(TestContainerBase)`
    flex-direction: row;
`;

const TestContainerColumn = styled(TestContainerBase)`
    flex-direction: column;
`;

interface TestSectionI extends React.PropsWithChildren{
    row: boolean
}

const TestSection: React.FC<TestSectionI> = (props): React.ReactElement<any> => {
    const component: React.ReactElement<any> = (
        props.row ?
            <TestContainerRow>{props.children}</TestContainerRow> :
            <TestContainerColumn>{props.children}</TestContainerColumn>
    );
    return (
        component
    );
};

const DocumentIconsSection = styled.div`
    display: flex; 
    justify-content: space-between;
    align-items: center;
    min-width: 80px;
`;

const TestLabelRow = styled(HeaderLabel)`
    padding-right: 10px;
`;



const TestLabel: React.FC<TestSectionI> = (props): React.ReactElement<any> => {
  const component: React.ReactElement<any> = (
      props.row ?
          <TestLabelRow>{props.children}</TestLabelRow> :
          <HeaderLabel>{props.children}</HeaderLabel>
  );
  return (
      component
  );
};

const TestTypeView: React.FC<TestTypeViewProps> = (props) => {
    const [showDocuments, setShowDocuments] = React.useState(false)
    const {t} = useTranslation()

        const{ test, row} = props;

        return (
            <TestSection row={row}>

                <TestLabel row={row}>
                    {t('requests.header.test')}
                </TestLabel>
                <span
                    style={{
                        paddingRight: (row ? '5px' : '0px')
                    }}
                >
                    {t(`test.${test.type}`)}
                </span>
                <DocumentIconsSection>
                    <Avatar>
                        {test.version}
                    </Avatar>
                    <Tooltip
                        title={t('tooltip.documents')}
                    >
                        <StyledLink
                            cursor={'pointer'}
                            onClick={() => {
                                setShowDocuments( true);
                            }}
                        >
                            <DocumentIcon color={'#cccccc'}/>
                        </StyledLink>
                    </Tooltip>
                    <TestDescroptionModal
                        showDocuments={showDocuments}
                        onCancel={() => {
                            setShowDocuments( false);
                        }}
                        testType={test.type}
                        testVersion={test.version}
                    />

                </DocumentIconsSection>

            </TestSection>

        );

}

export default TestTypeView;